// This is a special webpack variable that allows specifying public path
// on the fly. For more info check
// https://webpack.js.org/guides/public-path/#on-the-fly
// eslint-disable-next-line camelcase,no-undef
__webpack_public_path__ = global?.CONFIG?.HYDRA_STATIC_PREFIX || __webpack_public_path__
